import Icon from '../components/Icon.vue'

Icon.register({
  satellite: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.7 265c12.4 12.4 12.4 32.6-0.1 45l-96.7 96.7c-6.2 6.2-14.4 9.3-22.5 9.3-8.1 0-16.3-3.1-22.5-9.3l-80.3-80.4-9.9 9.9c24.3 53.7 22.7 116.2-5.4 168.5-4.5 8.5-16.4 9.6-23.2 2.8l-107.5-107.5-17.8 17.8c0.7 2.6 1.6 5 1.6 7.8 0 17.7-14.3 32-32 32-17.7 0-32-14.3-32-32 0-17.7 14.3-32 32-32 2.8 0 5.2 0.9 7.8 1.6l17.8-17.8-107.5-107.5c-6.8-6.8-5.7-18.6 2.8-23.2 52.3-28.1 114.8-29.7 168.5-5.4l9.8-9.8-80.3-80.4c-12.4-12.5-12.4-32.7 0-45.1l96.7-96.7c6.2-6.2 14.3-9.3 22.5-9.3s16.3 3.1 22.6 9.3l80.3 80.3 47.8-47.9c13.1-13.1 34.4-13.1 47.5 0l47.5 47.5c13.1 13.1 13.1 34.4 0 47.5l-47.8 47.9zM150.7 128.5l68.9 68.9 73.8-73.8-68.9-68.9zM383.5 361.3l73.8-73.8-68.9-68.9-73.8 73.8z'
      }
    ]
  }
})
